import { Link } from 'react-router-dom';
import type { NewsItem } from '@/types/content';

interface NewsCardProps {
  item: NewsItem;
  layout?: 'list' | 'compact';
}

const CATEGORY_STYLE: Record<string, string> = {
  新闻: 'bg-primary-100 text-primary-800',
  评论: 'bg-accent-100 text-accent-900',
  专题报道: 'bg-secondary-100 text-secondary-800',
  新番: 'bg-primary-100 text-primary-800',
  资讯: 'bg-secondary-100 text-secondary-800',
};

export default function NewsCard({ item, layout = 'list' }: NewsCardProps) {
  const catStyle = CATEGORY_STYLE[item.category] || 'bg-secondary-100 text-secondary-800';

  if (layout === 'compact') {
    return (
      <Link
        to={`/detail/news/${item.id}`}
        className="group flex cursor-pointer items-start gap-3 rounded-md border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-300"
      >
        <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-primary-100 text-xs font-700 text-primary-700">
          {item.title.slice(0, 1)}
        </span>
        <div className="min-w-0 flex-1">
          <h3 className="line-clamp-2 text-sm font-500 leading-snug text-foreground-900 group-hover:text-primary-700">
            {item.title}
          </h3>
          <span className="mt-1 block text-xs font-label text-foreground-500">{item.date}</span>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/detail/news/${item.id}`}
      className="group flex cursor-pointer flex-col gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 sm:flex-row"
    >
      <div className="h-44 w-full shrink-0 overflow-hidden rounded-md bg-background-200 sm:h-32 sm:w-56">
        <img
          src={item.cover}
          alt={`${item.title}配图`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="flex min-w-0 flex-1 flex-col">
        <div className="flex flex-wrap items-center gap-2">
          <span className={`rounded-md px-2 py-0.5 text-xs font-label font-500 ${catStyle}`}>{item.category}</span>
          <span className="text-xs font-label text-foreground-500">{item.date}</span>
          <span className="hidden text-xs font-label text-foreground-500 sm:inline">· {item.source}</span>
        </div>
        <h3 className="mt-2 line-clamp-2 font-heading text-base font-700 leading-snug text-foreground-950 group-hover:text-primary-700">
          {item.title}
        </h3>
        <p className="mt-2 line-clamp-2 flex-1 text-xs leading-relaxed text-foreground-600">{item.summary}</p>
        <div className="mt-2 flex flex-wrap items-center gap-1.5">
          {item.tags.slice(0, 3).map((tag) => (
            <span key={tag} className="rounded-md bg-background-100 px-2 py-0.5 text-xs font-label text-foreground-600">
              #{tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}